import { SmoothSampling } from '@shm-open/utilities';
import { addListener } from './event';
import { getServerTimeBySocket } from './websocket/stats';
// handle server time
// do sampling to smooth time diff
const httpDiffSampling = new SmoothSampling(8);
// side effects
addListener('response', (res) => {
    var _a;
    const date = (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('date');
    if (!date) {
        return;
    }
    const serverTime = new Date(date).getTime();
    const localTime = Date.now();
    const thisDiff = serverTime - localTime;
    httpDiffSampling.append(thisDiff);
});
/**
 * get current server time according to response time diff
 */
export function getServerTime() {
    // try websocket time first
    const timeBySocket = getServerTimeBySocket();
    if (timeBySocket) {
        return timeBySocket;
    }
    return Math.round(Date.now() + httpDiffSampling.get());
}
